var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},[_c('table',{staticStyle:{"padding-top":"5px"}},[_c('tbody',_vm._l((_vm.participants),function(user){return _c('tr',{key:user.id},[_c('td',{staticStyle:{"text-align":"center"}},[_c('img',{staticClass:"img-msg",attrs:{"src":user.imageUrl}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(user.name))])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-901b26dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatbot/UserList.vue
// module id = null
// module chunks = 